import { useCallback, useRef } from 'react';
function eventToPosition(evt) {
  return [evt.screenX, evt.screenY];
}
export function useTrackedPointer() {
  const lastPos = useRef([-1, -1]);
  const wasPointerMoved = useCallback(evt => {
    const newPos = eventToPosition(evt);
    if (lastPos.current[0] === newPos[0] && lastPos.current[1] === newPos[1]) {
      return false;
    }
    lastPos.current = newPos;
    return true;
  }, []);
  const pointerUpdate = useCallback(evt => {
    lastPos.current = eventToPosition(evt);
  }, []);
  return {
    pointerUpdate,
    wasPointerMoved
  };
}